// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__YEn_v","brand":"Avatar_brand__qLU6Y","slot":"Avatar_slot__Ub2nS","photo":"Avatar_photo__KTo98"};